export interface GalleryItem {
  image: string;
  title: string;
  text: string;
}

export const galleryItems: GalleryItem[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/gyycutziL1aCn35cL1n64t/01-Tecnica-recepcion.webp',
    title: 'Una referencia visual para corregir',
    text: 'Claves de recepción conectadas con una tarea para trabajarlas en pista.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/kvTuUekR3jTxkNqpnsFBZA/02-Ejercicio-pivote.webp',
    title: 'El ejercicio, explicado para aplicarlo',
    text: 'Montaje, ejecución, error frecuente y variantes para ajustar la dificultad.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/dBKmha9RpaQSejk4dPMRNF/03-Defensa-321.webp',
    title: 'La táctica también se ve',
    text: 'Posiciones y relaciones entre jugadores acompañadas de instrucciones de trabajo.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/5QwE1ixUnofJvNv28m1Nat/04-Sesion-parte-1.webp',
    title: 'Así empieza una sesión organizada',
    text: 'Objetivo, recursos y primeros bloques con tiempos y esquema de organización.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/5FjFotsS5EQtu74soJ8Mk9/05-Sesion-parte-2.webp',
    title: 'Así continúa esa misma sesión',
    text: 'Aplicación colectiva, reparto de jugadores, correcciones y adaptaciones.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/thDC93hcdFGRGNtKvAssQg/06-Registro-imprimible_(1).webp',
    title: 'Observa y decide el siguiente paso',
    text: 'Una hoja imprimible para registrar la respuesta del jugador y el próximo ajuste.'
  }
];
